import { graphql } from "../generated"

// Transfer request queries

export const getTransferRequestTemplateInfo = graphql(`
  query GetTransferRequestTemplateInfo {
    getDfeTransferRequestTemplateInfo {
      templateId
      templateRevisionId
    }
  }
`)

export const getTransferRequestDetails = graphql(`
  query GetTransferRequestDetails($id: ID!) {
    getTransferRequestDetails(input: { transferId: $id }) {
      certificateNumber
      requiresAttention
      id
      version
      isExhausted
      commodity {
        id
      }
      consignor {
        id
        name
        registrationId
        registrationTypeCode
      }
      consignee {
        id
        name
        registrationId
        registrationTypeCode
      }
      template {
        id
        code
        majorVersion
      }
      templateId
      templateCode
      destinationCountry {
        id
      }
      status {
        code
        label
      }
      attributes {
        address {
          id
          name
        }
        phytoSchemeControl {
          id
          name
        }
        phytoCertSubType {
          id
          name
        }
        phytoStatementOfRelabelling
        inspectionDate
        letterOfCreditRefCode {
          id
          name
        }
        numberOfPackagesContainers {
          id
          name
        }
        phytoPackhouse
        phytoLotRefNumber
        importPermitNumbers
        orgCertRefCode
        issuingAuthority {
          id
          name
        }
        issuingAuthority1 {
          id
          name
        }
        halalAuditor {
          id
          name
        }
        brandName {
          id
          name
        }
        summaryofRecordsfor {
          id
          name
        }
        categoryOfGoods {
          id
          name
        }
        euCommodityCode {
          id
          name
        }
        forImportorAdmission {
          id
          name
        }
        contractNo {
          id
          name
        }
        halalCertificateNumber {
          id
          name
        }
        sanitoryCertificateNumber {
          id
          name
        }
        cnInspection {
          id
          name
        }
        administrativeTerritorialUnit {
          id
          name
        }
        scope {
          id
          name
        }
        manufacturerRegistration {
          id
          name
        }
        manifacturingpremisesname {
          id
          name
        }
        productDescription {
          id
          name
        }
        purposeBR {
          id
          name
        }
        netWeightInWords {
          id
          name
        }
        euTransit {
          id
          name
        }
        exporterRef {
          id
          name
        }
        expRef {
          id
          name
        }
        markingofsealontransportcontai {
          id
          name
        }
        nameRegistrationandAddressofse {
          id
          name
        }
        numberOfDoses {
          id
          name
        }
        numberOfEmbryos {
          id
          name
        }
        placeandDateofQuarantine
        transport {
          id
          name
        }
        shipStores
        edReference {
          id
          name
        }
        exporterSignature {
          id
          name
        }
        lot {
          id
          name
        }
        exportingCountryId {
          id
          name
        }
        totalQuantity {
          id
          name
        }
        totalGrossWeight {
          id
          name
        }
        inspectionDateCaption
        importPermitNumbersCaption
        phytoCertificateNumber
      }
      reasonForStatusChange
      reasonForStateChangeCategories {
        id
        name
      }
      eligibility_declaration
      auditComment
      auditedAt
      auditedBy
      urgency {
        id
        name
      }
      unofficialInformation
      thirdPartyConsignor {
        id
        name
        registrationId
      }
      uniqueConsignmentReference
      transport {
        carrierName
        transportMode {
          id
          name
        }
        finalDestination {
          id
          name
        }
        departureDate
        expectedArrivalDate
        loadingPort {
          id
          name
        }
        dischargePort {
          id
          name
        }
        inspectionPort {
          id
          name
        }
        localCarrier
        localCarrierReference
        conveyanceReference
      }
      products {
        itemDescription {
          id
          name
        }
        id
        exhausted
        sequenceNumber
        sourceProcessCount
        processes {
          endDate
          foreignPremises
          foreignPremisesIdentifier
          id
          overrideProcessDate
          premises {
            id
            name
            registrationId
          }
          processType {
            id
            name
          }
          startDate
          isSourceProcess
          foreignPremisesCountryID {
            id
            name
          }
          updatedAt
          processGroup
          sequenceNumber
          nameOverride
          attributes {
            additionalTreatment
            chemicalDetail
            concentration
            duration {
              value
              unit {
                id
                name
              }
            }
            temperature {
              value
              unit {
                id
                name
              }
            }
          }
        }
        processHistory {
          createdAt
          dateOverride
          earliestStartDate
          id
          latestEndDate
          owned
          premisesIdentifier
          premisesName
          processCategory
          processCode
          processName
          lastProcessStartDate
          lastProcessEndDate
          concatenated
          latestSubmissionDate
          processSequenceNumber
        }
        classification {
          classificationCode
          classificationName
          createdAt
          fieldUniqueId
          id
          itemCode
          updatedAt
          value
        }
        containers {
          number
          seals
          id
        }
        productStatement
        productReference
        productDeclaration
        tradeLineGroupNumber
        sources {
          id
          sequenceNumber
          isExhausted
          transferRequestId
          transferRequestNumber
          isPaperSourced
          details {
            itemDescription {
              id
              name
            }
            eligibilityCountries {
              id
              name
            }
            classification {
              classificationCode
              classificationName
              createdAt
              fieldUniqueId
              id
              itemCode
              updatedAt
              value
            }
            attributes {
              expiryDateFrom
              expiryDateTo
              inspectionType {
                id
                name
              }
              intendedUse {
                id
                name
              }
              netVolume {
                unit {
                  id
                  name
                }
                value
              }
              netWeight {
                unit {
                  id
                  name
                }
                value
              }
              NZHSCode {
                id
                name
              }
              origin {
                id
                name
              }
              scientificName {
                id
                name
              }
              speciesCommonName {
                id
                name
              }
              grossWeight {
                unit {
                  id
                  name
                }
                value
              }
              grossVolume {
                unit {
                  id
                  name
                }
                value
              }
              temperature {
                id
                name
              }
              productionBatchIds
            }
            packaging {
              quantity
              itemMarksOuter
              outermostNumberOfPacakges
              packageType {
                id
                name
              }
              level
              nominalGrossVolume {
                unit {
                  id
                  name
                }
                value
              }
              nominalGrossWeight {
                unit {
                  id
                  name
                }
                value
              }
            }
            productReference
            productStatement
          }
        }
        eligibilityCountries {
          id
          name
        }
        attributes {
          productionBatchIds
          temperature {
            id
            name
          }
          netVolume {
            unit {
              id
              name
            }
            value
          }
          netWeight {
            unit {
              id
              name
            }
            value
          }
          grossVolume {
            unit {
              id
              name
            }
            value
          }
          grossWeight {
            unit {
              id
              name
            }
            value
          }
          inspectionType {
            id
            name
          }
          intendedUse {
            id
            name
          }
          origin {
            id
            name
          }
          speciesCommonName {
            id
            name
          }
          scientificName {
            id
            name
          }
          NZHSCode {
            id
            name
          }
          originCountries {
            id
            name
          }
          commonName {
            id
            name
          }
          expiryDateFrom
          expiryDateTo
        }
        packaging {
          quantity
          itemMarksOuter
          outermostNumberOfPacakges
          packageType {
            id
            name
          }
          level
          nominalGrossVolume {
            unit {
              id
              name
            }
            value
          }
          nominalGrossWeight {
            unit {
              id
              name
            }
            value
          }
        }
        supportingDocuments {
          id
          documentNumber
          documentReferenceNumber
          comment
          isInherited
          fileId
          primaryOperator {
            id
          }
          intendedOperators {
            id
          }
          status
        }
      }
    }
  }
`)

export const getTransferRequestHistory = graphql(`
  query GetTransferRequestHistory($input: TransferRequestHistoryInput!) {
    getTransferRequestHistory(input: $input) {
      id
      transferRequestId
      action
      status
      substatus
      reasonForStatusChange
      reasonCategories
      autoApproved
      updatedAt
      updatedBy
      updatedByFullName
      updatedByProfileName
      updatedByProfileFullName
      updatedBySystem
    }
  }
`)

export const getProductsByTransferReference = graphql(`
  query GetProductsByTransferReference($input: TransferReferenceRequestInput!) {
    getProductsByTransferReference(input: $input) {
      products {
        id
        sequenceNumber
        itemDescription {
          id
          name
        }
        attributes {
          origin {
            id
            name
          }
          netWeight {
            value
            unit {
              id
              name
            }
          }
          netVolume {
            value
            unit {
              id
              name
            }
          }
          intendedUse {
            id
            name
          }
          inspectionType {
            id
            name
          }
          NZHSCode {
            id
            name
          }
          speciesCommonName {
            id
            name
          }
          scientificName {
            id
            name
          }
          commonName {
            id
            name
          }
          expiryDateTo
          expiryDateFrom
          temperature {
            id
            name
          }
          grossWeight {
            value
            unit {
              id
              name
            }
          }
          grossVolume {
            value
            unit {
              id
              name
            }
          }
          productionBatchIds
        }
        classification {
          classificationCode
          classificationName
          createdAt
          fieldUniqueId
          id
          itemCode
          updatedAt
          value
        }
        packaging {
          outermostNumberOfPacakges
          itemMarksOuter
          itemMarksOuterCaption
          quantity
          level
          packageType {
            id
            name
          }
          nominalGrossWeight {
            value
            unit {
              id
              name
            }
          }
          nominalGrossVolume {
            value
            unit {
              id
              name
            }
          }
        }
        eligibilityCountries {
          id
          name
        }
        processes {
          id
          premises {
            id
            name
            registrationId
          }
          processType {
            id
            name
          }
          startDate
          endDate
          foreignPremises
          foreignPremisesIdentifier
          overrideProcessDate
        }
        sources {
          id
          sequenceNumber
          transferRequestId
          transferRequestNumber
          isPaperSourced
          details {
            itemDescription {
              id
              name
            }
            eligibilityCountries {
              id
              name
            }
            attributes {
              expiryDateFrom
              expiryDateTo
              inspectionType {
                id
                name
              }
              intendedUse {
                id
                name
              }
              netVolume {
                unit {
                  id
                  name
                }
                value
              }
              netWeight {
                unit {
                  id
                  name
                }
                value
              }
              NZHSCode {
                id
                name
              }
              origin {
                id
                name
              }
              scientificName {
                id
                name
              }
              speciesCommonName {
                id
                name
              }
            }
          }
        }
        supportingDocuments {
          id
          documentNumber
          comment
          isInherited
          isLinked
        }
        containers {
          id
          number
          seals
        }
        transferRequestId
        transferRequestNumber
        quantity {
          value
          unit {
            id
            name
          }
        }
        exhausted
        productStatement
        productReference
      }
      errors {
        transferNumber
        lineItem
        errorCode
        errorMessage
      }
    }
  }
`)

export const getForwardProductTracking = graphql(`
  query GetForwardProductTracking($transferRequestId: ID!) {
    getForwardProductTracking(transferRequestId: $transferRequestId) {
      sourceProducts {
        id
        productNumber
        description
        quantity
        outgoingCount
        totalPackages
        destinations {
          id
          sourceNumber
          sourceStatus
          requestId
          requestNumber
          requestType
          productItem
          status
          templateVersion
          isExhausted
          productDescription
          quantity
          packagingType
        }
      }
    }
  }
`)
